// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-item-background {
  padding: 15px 0;
}
.action-item-background ion-card {
  box-shadow: 1px 1px 2px 1px #c7c7c7;
  border-radius: 5px;
}

ion-badge.action-item-count {
  padding: 10px;
  width: 60px;
  margin: 15px auto 15px;
  display: block;
  position: relative !important;
  color: #fff !important;
}
ion-badge.action-item-count span {
  font-size: 15px;
}

ion-searchbar {
  box-shadow: none;
  border: 1px solid #e4dfdf;
  margin: 10px 10px 0 10px;
  width: calc(100% - 20px);
}

.notification-list {
  height: calc(100vh - 260px);
  overflow: auto;
}

.notification-list ion-item {
  border-bottom: 1px solid #dedede;
  padding-top: 5px;
  padding-bottom: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/trip-information/trip-activities/trip-activities.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,mCAAA;EACA,kBAAA;AACJ;;AAGA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,6BAAA;EACA,sBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;;AAIA;EACE,gBAAA;EACA,yBAAA;EACA,wBAAA;EACA,wBAAA;AADF;;AAIA;EACE,2BAAA;EACA,cAAA;AADF;;AAIA;EACE,gCAAA;EACA,gBAAA;EACA,mBAAA;AADF","sourcesContent":[".action-item-background {\n  padding: 15px 0;\n\n  ion-card {\n    box-shadow: 1px 1px 2px 1px #c7c7c7;\n    border-radius: 5px;\n  }\n}\n\nion-badge.action-item-count {\n  padding: 10px;\n  width: 60px;\n  margin: 15px auto 15px;\n  display: block;\n  position: relative !important;\n  color: #fff !important;\n\n  span {\n    font-size: 15px;\n  }\n}\n\nion-searchbar {\n  box-shadow: none;\n  border: 1px solid #e4dfdf;\n  margin: 10px 10px 0 10px;\n  width: calc(100% - 20px);\n}\n\n.notification-list {\n  height: calc(100vh - 260px);\n  overflow: auto;\n}\n\n.notification-list ion-item {\n  border-bottom: 1px solid #dedede;\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
